<div class="print-toolbar">
  <div class="print-toolbar__inner">
    <a class="pro-options__actions-btn" (click)="onPrint()">
      <svg class="icon pro-options__actions-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" /></svg>
      Print
    </a>
    <div class="print-toolbar__options">
      @if (peer()?.group) {
      <div>
        <label class="check-control">
          <input type="checkbox" [(ngModel)]="printGroupCheckbox" [ngModelOptions]="{ standalone: true }" (change)="printGroup.set(printGroupCheckbox)" value="false" />
          <span class="check-control__text">Include list of institutions in peer group</span>
        </label>
      </div>
      }
      <div>
        <label class="check-control">
          <input type="checkbox" [(ngModel)]="printInfoCheckbox" [ngModelOptions]="{ standalone: true }" (change)="printInfo.set(printInfoCheckbox)" value="false" />
          <span class="check-control__text">Include information boxes</span>
        </label>
      </div>
    </div>
  </div>
</div>

<!--<table style="width: 100%;">-->
<table style="pointer-events: none; width: 100%;">
  <thead>
    <tr>
      <td>
        <div class="print-header">
          <img class="print-header__left" src="/api/image/logo" height="64" />
          <div class="print-header__center">
            {{ institution().name }}<br />
            {{ pageName() }}<br />
            {{ headerDate() }}
          </div>
          <div class="print-header__right">
            Run Date: {{ runDate | date: 'MMM dd, yyyy' }}<br />
            LakeHouse Analytics
          </div>
        </div>
        <!--<app-print-header></app-print-header>-->
      </td>
    </tr>
  </thead>
  <tbody>
    <!--<tr>
      <td>
        <ng-container #institutionSelector></ng-container>
      </td>
    </tr>-->
    <tr>
      <td>
        <div class="content">
          <div class="content__inner">
            <!--<ng-container #productHeader></ng-container>-->
            <div class="pro-widgets">
              <ng-container #flexContainer></ng-container>
            </div>
            <ng-container #legend></ng-container>
            @if (printGroup()) {
            <app-print-group></app-print-group>
            }
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<div #dialog></div>
